import * as React from 'react';
import styled from 'styled-components';

import { Icon } from '@longline/aqua-ui/controls/Icon';
import { SVG } from '@longline/aqua-ui/svg';

import { useGlobalState } from '../../contexts/state/GlobalStateContext';
import { DeleteIcon } from '../../contexts/confirm/DeleteIcon';
import { IArea } from '../../types/IArea';

interface IProps {
  className?: string;
  value: IArea;
  withClose?: boolean;
}

const AreaInfoBoxHeaderBase = (props: IProps) => {
  const globalState = useGlobalState();

  const handleClose = () => {
    globalState.setSelectedArea(null);
  }

  const handleKeyDown = (ev: KeyboardEvent) => {
    if(ev.code == 'Escape') handleClose();
  }

  React.useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  return (
    <div className={props.className}>
      <Block>
        {props.value.name}
      </Block>
      <Block>
        <DeleteIcon confirm title="Delete this simulation area" text="Are you sure you wish to delete this simulation area?" onClick={() => globalState.deleteArea(props.value)}/>
        {props.withClose && <Icon url={SVG.Icons.Cross} onClick={handleClose}/>}
      </Block>
    </div>
  )
}

const Block = styled.div`
  display: flex;
  flex-direction: row;  
  justify-content: start;
  gap: 8px;
  align-items: center;
`

const AreaInfoBoxHeaderStyled = styled(AreaInfoBoxHeaderBase)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const AreaInfoBoxHeader = (props: IProps) => <AreaInfoBoxHeaderStyled {...props}/>

export { AreaInfoBoxHeader }
